import { render, staticRenderFns } from "./BatimentCollectView.vue?vue&type=template&id=ca44792a&scoped=true&"
import script from "./BatimentCollectView.vue?vue&type=script&lang=js&"
export * from "./BatimentCollectView.vue?vue&type=script&lang=js&"
import style0 from "./BatimentCollectView.vue?vue&type=style&index=0&id=ca44792a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca44792a",
  null
  
)

export default component.exports